import { Component, ViewChild } from '@angular/core';
import { AlertController, Content, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateCondidtionsPipe } from '../../shared/translate-conditions.pipe';
import { DetailPage } from '../detail/detail';
import { SearchService } from '../../providers/search';
import { ErrorHandling } from '../../shared/error.handling';
import { TranslateCategoryPipe } from '../../shared/translate-category.pipe';
import { SearchPage } from '../search/search';

@Component({
    selector: 'page-searchresults',
    templateUrl: 'searchresults.html'
})
export class SearchresultsPage {

    @ViewChild(Content) content: Content;

    resultList: any;
    resultTotalCount: number;
    category: string;
    searchTerm: string;
    searchFilter: any;
    hierachieField: string;
    searchSort: any = 'Text>';
    inifinteScroll: boolean = true;
    searchFields: string;
    searchType: any = 0;
    switchDateNote: boolean = false;
    searchLevel1: number;
    searchSecondarySet: boolean = false; // Flag - Suche in untern Hierachiebenen daktiviert

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public alertCtrl: AlertController,
                public toastCtrl: ToastController,
                public loadingCtrl: LoadingController,
                public searchService: SearchService,
                public errorHandling: ErrorHandling) {

        this.category = navParams.get('category');
        this.resultTotalCount = navParams.get('resultTotalCount');
        this.searchLevel1 = navParams.get('searchLevel1');
        if(this.searchLevel1 == 1){
            this.searchSecondarySet = true;
        }
        this.searchTerm = navParams.get('searchTerm');
        this.searchFilter = navParams.get('searchFilter');
        this.hierachieField = navParams.get('hierachieField');
        this.searchFields = navParams.get('searchFields');
        this.searchType = navParams.get('searchType'); // ist '1' wenn Hierachiesuche ausgeführt wurde
        this.resultList = navParams.get('resultList'); //
    }

    ionViewDidEnter(){
        console.log('ionViewDidEnter SearchresultsPage');
        // gespeicherte Sortierung auslesen
        let storedSort = JSON.parse(localStorage.getItem('sorting'));
        let tempSort = storedSort[this.category];
        console.log('ionViewDidEnter() -> storedSort: ', storedSort);
        console.log('ionViewDidEnter() -> tempSort: ', tempSort);
        this.searchSort = tempSort;
    }

    /**
     * Pushes id and type to nav controller
     * @param {number} id
     * @param {string} type
     */
    getDetails(id: number, type: string) {

        let translateCondidtionsPipe = new TranslateCondidtionsPipe();
        let orgaStruct = translateCondidtionsPipe.transform(type);

        this.navCtrl.push(DetailPage, {'objId': id, 'orgaStruct': orgaStruct});
    }

    /**
     * Loads next results fro infinite scroll
     * @param infiniteScroll
     */
    getNextResults(infiniteScroll) {
        if (this.searchType != 1) { //Standard search from search page

            this.searchService.search(this.searchTerm, this.category, this.searchFilter, this.searchSort, this.resultList.length, this.hierachieField)
                .subscribe(
                    (success) => {
                        setTimeout(() => {
                            this.resultList = this.resultList.concat(success.results);
                            if (success.resultTotalCount === 0) {
                                infiniteScroll.enable(false);

                                if (this.inifinteScroll) {
                                    let toast = this.toastCtrl.create({
                                        message: 'Es gibt keine weiteren Suchergebnisse.',
                                        position: 'bottom',
                                        duration: 1500
                                    });

                                    toast.present().then(() => {

                                this.inifinteScroll = false;});
                                }
                            }

                            infiniteScroll.complete();
                        }, 300);
                    }, (error) => {
                        this.errorHandling.handle(error, 'SearchResults -> getNextResults (Standard)');
                    }
                );
        } else if (this.searchType == 1) { //Hierarchy search from detail page (buttons etc.)

            this.searchService.searchHierarchy(this.searchTerm, this.category, this.hierachieField, this.resultList.length)
                .subscribe(
                    (success) => {
                        setTimeout(() => {
                            this.resultList = this.resultList.concat(success.results);

                            if (success.resultTotalCount === 0) {
                                infiniteScroll.enable(false);

                                if (this.inifinteScroll) {
                                    let toast = this.toastCtrl.create({
                                        message: 'Es gibt keine weiteren Suchergebnisse.',
                                        position: 'top',
                                        duration: 2000
                                    });
                                    toast.present();
                                }
                                this.inifinteScroll = false;
                            }
                            infiniteScroll.complete();
                        }, 300);
                    },
                    (error) => {
                        this.errorHandling.handle(error, 'SearchResults -> getNextResults (Hierarchie)');
                    }
                );
        }
    }

    /** Scrolls to the top of the page */
    scrollToTop() {
        this.content.scrollToTop();
    }

    /** Navigates back to search page */
    getSearchPage() {
        this.navCtrl.setRoot(SearchPage, {}, {direction: 'back'});
    }

    /** Opens alert with different contents*/
    openRadioAlert() {
        let alert = this.alertCtrl.create();
        alert.setTitle('Sortierung');

        alert.addInput({
            type: 'radio',
            label: 'Text alphabetisch aufsteigend',
            value: 'Text>',
            checked: this.searchSort === 'Text>'
        });
        alert.addInput({
            type: 'radio',
            label: 'Text alphabetisch absteigend',
            value: 'Text<',
            checked: this.searchSort === 'Text<'
        });

        if (this.category === 'Structure') {
            alert.addInput({
                type: 'radio',
                label: 'Aktenzeichen aufsteigend',
                value: 'Aktenzeichen>',
                checked: this.searchSort === 'Aktenzeichen>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Aktenzeichen absteigend',
                value: 'Aktenzeichen<',
                checked: this.searchSort === 'Aktenzeichen<'
            });
        }

        if (this.category === 'Document') {
            alert.addInput({
                type: 'radio',
                label: 'Änderungsdatum aufsteigend',
                value: 'ADatum>',
                checked: this.searchSort === 'ADatum>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Änderungsdatum absteigend',
                value: 'ADatum<',
                checked: this.searchSort === 'ADatum<'
            });
            alert.addInput({
                type: 'radio',
                label: 'Erstellungsdatum aufsteigend',
                value: 'Datum>',
                checked: this.searchSort === 'Datum>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Erstellungsdatum absteigend',
                value: 'Datum<',
                checked: this.searchSort === 'Datum<'
            });
            alert.addInput({
                type: 'radio',
                label: 'Aktenzeichen aufsteigend',
                value: 'Aktenzeichen>',
                checked: this.searchSort === 'Aktenzeichen>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Aktenzeichen absteigend',
                value: 'Aktenzeichen<',
                checked: this.searchSort === 'Aktenzeichen<'
            });
        }

        if (this.category === 'Folder') {
            alert.addInput({
                type: 'radio',
                label: 'Datum aufsteigend',
                value: 'BeginnDatum>',
                checked: this.searchSort === 'BeginnDatum>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Datum absteigend',
                value: 'BeginnDatum<',
                checked: this.searchSort === 'BeginnDatum<'
            });

            alert.addInput({
                type: 'radio',
                label: 'Vorgangskennung aufsteigend',
                value: 'Vorgangskennung>',
                checked: this.searchSort === 'Vorgangskennung>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Vorgangskennung absteigend',
                value: 'Vorgangskennung<',
                checked: this.searchSort === 'Vorgangskennung<'
            });
        }

        if (this.category === 'Address') {
            alert.addInput({
                type: 'radio',
                label: 'Adresskennung aufsteigend',
                value: 'Adresskennung>',
                checked: this.searchSort === 'Adresskennung>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Adresskennung absteigend',
                value: 'Adresskennung<',
                checked: this.searchSort === 'Adresskennung<'
            });

            alert.addInput({
                type: 'radio',
                label: 'Name aufsteigend',
                value: 'Name1>;Nachname>',
                checked: this.searchSort === 'Name1>;Nachname>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Name absteigend',
                value: 'Name1<;Nachname<',
                checked: this.searchSort === 'Name1<;Nachname<'
            });
        }

        if (this.category === 'Meeting') {
            alert.addInput({
                type: 'radio',
                label: 'Sitzungsdatum aufsteigend',
                value: 'Sitzungsdatum>',
                checked: this.searchSort === 'Sitzungsdatum>'
            });
            alert.addInput({
                type: 'radio',
                label: 'Sitzungsdatum absteigend',
                value: 'Sitzungsdatum<',
                checked: this.searchSort === 'Sitzungsdatum<'
            });
        }

        alert.addButton('Abbrechen');
        alert.addButton({
            text: 'OK',
            handler: data => {

                this.searchSort = data;
                this.inifinteScroll = true;

                // Sortierung in localstorage speichern
                this.storeSorting(data, this.category);

                if(data == 'Datum>' || data == 'Datum<'){
                    this.switchDateNote = true;
                } else {
                    this.switchDateNote = false;
                }
                //this.sortResults();
                this.searchInResultList(false);
            }
        });
        alert.present();
    }

    /*
     * storeSorting()
     * Sortierung  wird in localStorage als Benutzer-Einstellung gespeichert
     *
     * @param sorting: String
     * @param category: String
     */
    storeSorting(sorting:string, category:string){

        console.log('storeSorting() -> filterObj: ', sorting);
        console.log('storeSorting() -> category: ', this.category);

        let storedSorting = localStorage.getItem('sorting');
        console.log('storeSorting() -> storedSorting: ', storedSorting);

        let tempSorting = JSON.parse(storedSorting);
        tempSorting[category] = sorting;

        console.log('storeSorting() -> tempSorting: ', tempSorting);
        console.log('storeSorting() -> tempSorting[category]: ', tempSorting[category]);

        localStorage.setItem('sorting', JSON.stringify(tempSorting));

    }

    /*
    * searchInResultList()
    *
    * Suche in / Sortierung der Ergebnisliste
    * @param setSearchLevel1: boolen
    */
    searchInResultList(setSearchLevel1?:boolean){

        console.log('??? searchSecondary: ');
        console.log('??? searchSecondary hierachieField: ', this.hierachieField);

        let loader = this.loadingCtrl.create();
        loader.present();

        if(this.searchLevel1 == 0) {
            this.searchSecondarySet = true;
        } else {
            this.searchSecondarySet = false;
        }

        if(setSearchLevel1){
            this.searchSecondarySet = true;
        } else {


        }

        console.log('??? searchSecondary searchSecondarySet: ', this.searchSecondarySet);

        this.searchService.search(this.searchTerm, this.category, this.hierachieField,'','','', setSearchLevel1)
            .subscribe((success) => {
                let searchResults = success.results;

                console.log('searchInResultList -> searchResults: ', success);

                if (searchResults) {
                    this.navCtrl.push(SearchresultsPage, {
                        'resultList': searchResults,
                        'resultTotalCount': success.resultTotalCount,
                        'category': this.category,
                        'searchTerm': this.searchTerm,
                        'searchFilter': false,
                        'hierachieField': this.hierachieField,
                        'searchType': 0,
                        'searchLevel1': 1,
                    });
                } else {

                }

                loader.dismiss();

            }, (error) => {
                this.errorHandling.handle(error, 'searchresults -> - searchSecondary')
                loader.dismiss();
            })

    }

    /** Sorts the search results */
    sortResults() {
        let loader = this.loadingCtrl.create();
        loader.present();

        this.inifinteScroll = true;

        this.searchService.search(this.searchTerm, this.category, this.searchFilter, this.searchSort)
            .subscribe(
                (success) => {
                    loader.dismiss();

                    if (success.results.length > 0) {
                        this.resultList = success.results;
                        this.resultTotalCount = success.results.resultTotalCount;
                    } else {
                        let translateCategoryPipe = new TranslateCategoryPipe();
                        let searchCategoryString = translateCategoryPipe.transform(this.category);

                        let alert = this.alertCtrl.create({
                            title: 'Suche ' + searchCategoryString,
                            subTitle: 'Keine ' + searchCategoryString + ' gefunden!',
                            buttons: ['Ok']
                        });
                        alert.present();
                    }
                },
                (error) => {
                    loader.dismiss();
                    this.errorHandling.handle(error, 'Search');
                }
            );
    }

    /*
     * getSubStructures()
     *
     */
    getSubStructures(term, cat, field, item, event){
        event.stopPropagation(); // Prevent that the click is casted to the div below as well in order to prevent a double navigation.
        let filter: boolean = false;
        let loader = this.loadingCtrl.create();
        loader.present();

        this.searchService.searchHierarchy(term, cat, field)
            .subscribe(
                (success) => {
                    let searchResults = success.results;

                    if (searchResults) {
                        this.navCtrl.push(SearchresultsPage, {
                            'resultList': searchResults,
                            'resultTotalCount': success.resultTotalCount,
                            'category': cat,
                            'searchTerm': term,
                            'searchFilter': filter,
                            'hierachieField': field,
                            'searchType': 1
                        });
                    }

                    loader.dismiss();
                }, (error) => {
                    this.errorHandling.handle(error, 'searchresults -> - getSubStructures')
                    loader.dismiss();
                });

        // sliding-item schließen
        item.close();
    }
}



// WEBPACK FOOTER //
// ./src/pages/searchresults/searchresults.ts